module.exports = __webpack_public_path__ + "img/window.123b7d24.svg";